import { render } from "./CurrentAds.vue?vue&type=template&id=45a24646&scoped=true"
import script from "./CurrentAds.vue?vue&type=script&lang=js"
export * from "./CurrentAds.vue?vue&type=script&lang=js"

import "./CurrentAds.vue?vue&type=style&index=0&id=45a24646&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a24646"]])

export default __exports__